import script from "./ProjectStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectStatus.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectStatus.vue?vue&type=style&index=0&id=13647f15&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13647f15"]])

export default __exports__